<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-expansion-panel class="custom-panel">
          <v-expansion-panel-content expand-icon="fas fa-caret-down fa-xs black--text left"
            expand-icon-class="expand-icon-left" class="mb-4">
            <template slot="header">
              <v-layout row wrap>
                <v-flex xs12 class="d-flex align-start justify-start mr-4">
                  <div class="priority-frame priority-one">
                    <img :src="require('@/assets/img/prioridad_III_icon.svg')" alt="Prioridad Icon"
                      class="priority-icon">
                  </div>
                </v-flex>
                <v-flex xs10 class="d-flex align-center justify-end pl-4">
                  <h2 class="ml-4 pl-4">Segmentos compromiso</h2>
                </v-flex>
                <v-flex xs2 class="d-flex align-center justify-end">
                  <v-btn v-if="canCreate" @click.stop="createPStage" class="k-orange-linear white--text">CREAR SEGMENTO</v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-card>
              <v-card-text>
                <v-container>
                  <v-layout column wrap>
                    <v-flex xs12>
                      <v-icon class="toggle-icon" @click="toggleAll(1)">{{ `fas fa-caret-${stStatus1} fa-xs black--text`
                        }}</v-icon>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                      <v-divider />
                    </v-flex>
                    <stages-list
                      :stages="pStages"
                      :toggleAll="toggleAll1"
                      :is-in-release="isInRelease"
                      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
                      @channel-settings="openChannelSettings"
                      @test-template="openTestModal"
                      @edit-stage="editPStage"
                      @edit-stage-filter="editPStageFilter"
                      @create-stage-filter="createPFilter"
                      @change-stage-status="changeStageStatus"
                      @filter-updated="pFilterUpdated"
                    />
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content expand-icon="fas fa-caret-down fa-xs black--text"
            expand-icon-class="expand-icon-left" class="mb-4">
            <template slot="header">
              <v-layout row wrap>
                <v-flex xs12 class="d-flex align-start justify- mr-4">
                  <div class="priority-frame priority-two">
                    <img :src="require('@/assets/img/prioridad_II_icon.svg')" alt="Prioridad Icon"
                      class="priority-icon ml-1">
                  </div>
                </v-flex>
                <v-flex xs10 class="d-flex align-center justify-end pl-4">
                  <h2 class="ml-4 pl-4">Segmentos globales</h2>
                </v-flex>
                <v-flex xs2 class="d-flex align-center justify-end">
                  <v-btn v-if="canCreate" @click="createStage(true)" class="k-orange-linear white--text">CREAR SEGMENTO</v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-card>
              <v-card-text>
                <v-container>
                  <v-layout column wrap>
                    <v-flex xs12>
                      <v-icon class="toggle-icon" @click="toggleAll(2)">{{ `fas fa-caret-${stStatus2} fa-xs black--text`
                        }}</v-icon>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                      <v-divider />
                    </v-flex>
                    <stages-list 
                      :stages="globalStages"
                      :toggleAll="toggleAll2"
                      :is-global="true"
                      :is-in-release="isInRelease"
                      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
                      @delete-filter="deleteFilter"
                      @channel-settings="openChannelSettings"
                      @test-template="openTestModal"
                      @change-stage-status="changeStageStatus"
                      @edit-stage="editStage"
                      @filter-updated="filterUpdated"
                      @edit-stage-filter="editStageFilter"
                      @create-stage-filter="createStageFilter"
                      @set-stage="setStage"
                    />
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content expand-icon="fas fa-caret-down fa-xs black--text"
            expand-icon-class="expand-icon-left">
            <template slot="header">
              <v-layout row wrap>
                <v-flex xs12 class="d-flex align-start justify-start mr-4">
                  <div class="priority-frame priority-three">
                    <img :src="require('@/assets/img/prioridad_I_icon.svg')" alt="Prioridad Icon" class="priority-icon">
                  </div>
                </v-flex>
                <v-flex xs10 class="d-flex align-center justify-end pl-4">
                  <h2 class="ml-4 pl-4">Segmentos normales</h2>
                </v-flex>
                <v-flex xs2 class="d-flex align-center justify-end">
                  <v-btn v-if="canCreate" @click="createStage(false)" class="k-orange-linear white--text">CREAR SEGMENTO</v-btn>
                </v-flex>
              </v-layout>
            </template>
            <v-card>
              <v-card-text>
                <v-container>
                  <v-layout column wrap>
                    <v-flex xs12>
                      <v-icon class="toggle-icon" @click="toggleAll(3)">{{ `fas fa-caret-${stStatus3} fa-xs black--text`
                        }}</v-icon>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                      <v-divider />
                    </v-flex>
                    <stages-list
                      :stages="normalStages"
                      :toggleAll="toggleAll3"
                      :is-in-release="isInRelease"
                      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
                      @delete-filter="deleteFilter" 
                      @set-stage="setStage" 
                      @test-template="openTestModal"
                      @edit-stage="editStage" 
                      @filter-updated="filterUpdated"
                      @edit-stage-filter="editStageFilter" @create-stage-filter="createStageFilter"
                      @change-stage-status="changeStageStatus"
                    />
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
    <stage-modal :show="stageModal" :global="selectedStageGlobal" :stage="selectedStage" :max-order="maxOrderStage"
      @created="$emit('stage-created', $event)" @updated="$emit('stage-updated', $event)" @close="stageModal = false"
      @delete-stage="deleteStage" />
    <p-stage-modal :show="pStageModal" :p-stage="selectedPStage" @created="$emit('p-stage-created', $event)"
      @updated="$emit('p-stage-updated', $event)" @close="pStageModal = false" @delete-p-stage="deletePStage" />
    <confirm-dialog :show="showDeleteFilter" :message="deleteMessage" @accept="destroyFilter"
      @close="showDeleteFilter = false">
    </confirm-dialog>
    <delete-dialog :show="deleteModal" :url="deleteUrl" :message="deleteMessage" @deleted="deletedEvt"
      @close="deleteModal = false" />
    <edit-modal :show="stageFilterModal" :stage="selectedStage" :filter="selectedStageFilter"
      @delete="deleteStageFilter" @updated="updatedStageFilter" @close="stageFilterModal = false"
      @created="createdStageFilter" />
    <p-filter-modal :show="pFilterModal" :p-stage="selectedPStage" :p-filter="editingFilter"
      @delete="deletePFilter" @created="createdPFilter" @updated="updatePFilter"
      @close="pFilterModal = false" />
    <test-template-dialog
      :show="testTemplateDialog"
      :template-id="testTemplateId"
      :channel="testChannelId"
      @close="closeTestModal" />
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';

import EventBus from '@/event-bus';
import StagesList from './StageListV2.vue';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import StageModal from '@/components/V2CollectWorkflows/Detail/WorkflowTree/StageModal';
import FilterModal from '@/components/V2CollectWorkflows/Detail/WorkflowTree/FilterModal';
import PStageModal from '@/components/CollectWorkflows/Detail/PaymentPromiseTree/PStageModal';
import ConfirmDialog from '@/components/global/ConfirmDialog';
import DeleteDialog from '@/components/global/DeleteDialog2';
import EditModal from '@/components/V2CollectWorkflows/Detail/WorkflowDetail/editModal';
import PFilterModal from '@/components/V2CollectWorkflows/Detail/PaymentPromiseTree/PFilterModalV2';
import permissionsMixin from '@/mixins/permissions';

export default {
  props: {
    workflow: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
    pStages: {
      type: Array,
      required: true,
    },
    stagesKey: {
      type: String,
      required: true,
    },
    isInRelease: {
      type: Boolean,
      defalut: false,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StagesList,
    FilterModal,
    DeleteDialog,
    TestTemplateDialog,
    StageModal,
    PStageModal,
    ConfirmDialog,
    DeleteDialog,
    EditModal,
    PFilterModal,
  },
  mixins: [ permissionsMixin ],
  data() {
    return {
      testTemplateDialog: false,
      testTemplateId: 0,
      selectedStageGlobal: false,
      stageModal: false,
      filtersModal: false,
      selectedStageId: 0,
      selectedFilter: {},
      deleteModal: false,
      deleteType: 'stage',
      templateId: 0,
      toggleAll1: false,
      toggleAll2: false,
      toggleAll3: false,
      stStatus1: 'down',
      stStatus2: 'down',
      stStatus3: 'down',
      showChannelSettings: false,
      editingChannel: '',
      editingFilter: {},
      pStageModal: false,
      selectedPStageId: 0,
      showDeleteFilter: false,
      deleteFilterTmp: {},
      deleteMessage: '',
      selectedStageFilter: {},
      stageFilterModal: false,
      pFilterModal: false,
      testTemplateDialog: false,
      testTemplateId: 0,
      testChannelId: 0,
    };
  },
  computed: {
    canCreate() {
      return this.checkPermissions([
        'create_workflow_notifications',
        'edit_workflow_notifications',
      ]);
    },
    globalStages() {
      return _.sortBy(this.stages.filter(item => item.global), item => parseInt(item.order, 10));
    },
    normalStages() {
      return _.sortBy(this.stages.filter(item => !item.global), item => parseInt(item.order, 10));
    },
    maxOrderStage() {
      let maxOrder;
      if (this.selectedStageGlobal) {
        maxOrder = this.globalStages.length;
      } else {
        maxOrder = this.normalStages.length;
      }
      return maxOrder + 1;
    },
    selectedStage() {
      const stage = this.stages.find(item => item.id === this.selectedStageId) || {};
      if (Object.keys(stage).length && typeof (stage.stage_filters) === 'string') {
        stage.stage_filters = JSON.parse(stage.stage_filters || JSON.stringify({
          type: 'group',
          operator: 'and',
          items: [],
        }));
      }
      return stage;
    },
    deleteUrl() {
      let url = '';
      if (this.deleteType === 'stage') {
        url = `stages/${this.selectedStage.id}`;
      } else if (this.deleteType === 'p-stage') {
        url = `payment_p_stages/${this.selectedPStage.id}`;
      } else if (this.deleteType === 'stage-filter') {
        url = `v2/workflow_filters/${this.selectedFilter.id}`;
      } else {
        url = `payment_p_filters/${this.selectedFilter.id}`;
      }
      return url;
    },
    maxOrderStage() {
      let maxOrder;
      if (this.selectedStageGlobal) {
        maxOrder = this.globalStages.length;
      } else {
        maxOrder = this.normalStages.length;
      }
      return maxOrder + 1;
    },
    selectedPStage() {
      return this.pStages.find(item => item.id === this.selectedPStageId) || {};
    },
  },
  methods: {
    editPStageFilter(event) {
      this.selectedPStageId = event.stage.id;
      this.editingFilter = event.filter;
      this.pFilterModal = true;
    },
    createPFilter(event) {
      this.selectedPStageId = event.id;
      this.pFilterModal = true;
    },
    updatePFilter(event) {
      this.$emit('p-filter-updated', {selectedPStage: this.selectedPStage, pFilter: event});
    },
    createdPFilter(event) {
      this.$emit('p-filter-created', {pFilter:event, selectedPStage: this.selectedPStage});
    },
    createStageFilter(event) {
      this.selectedStageId = event.id;
      this.stageFilterModal = true;
    },
    createdStageFilter(event) {
      this.$emit('filter-created', { selectedStage: this.selectedStage, filter: event });
    },
    deleteStageFilter(event) {
      this.deleteType = 'stage-filter';
      this.selectedFilter = event.filter;
      this.selectedStageId = event.stage.id;
      this.deleteMessage = '¿Deseas eliminar esta estrategia? Esta acción es irreversible.';
      this.deleteModal = true;
    },
    deletePFilter(event){
      this.deleteType = 'p-filter';
      this.selectedFilter = event.filter;
      this.selectedPStageId = event.stage.id;
      this.deleteMessage = '¿Deseas eliminar esta estrategia? Esta acción es irreversible.';
      this.deleteModal = true;
    },
    updatedStageFilter(event) {
      this.$emit('filter-updated', { selectedStage: this.selectedStage, filter: { ...event } });
    },
    editStageFilter(data) {
      const { stage, filter } = data;
      this.selectedStageId = stage.id
      this.selectedStageFilter = filter;
      this.stageFilterModal = true;
    },
    async changeStageStatus(data) {
      const { stageId, payload, isPaymentType } = data;
      const response = await this.sendStageRequest(stageId, payload, isPaymentType);

      if (!response) {
        EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente');
        return;
      }
      let emitEvent;
      if (!isPaymentType) {
        emitEvent = 'stage-updated';
      } else {
        emitEvent = 'p-stage-updated';
      }
      this.$emit(emitEvent, response);
    },
    sortPStages() {
      this.pStages = _.sortBy(this.pStages, item => parseInt(item.days_off, 10));
      this.pStagesKey = uuidv1();
    },
    destroyFilter() {
      this.$emit('delete-filter', this.deleteFilterTmp);
      this.deleteFilterTmp = {};
    },
    deleteFilter(event) {
      this.deleteFilterTmp = event;
      this.deleteMessage = '¿Deseas eliminar esta estrategia? Esta acción es irreversible.';
      this.showDeleteFilter = true;
    },
    pFilterUpdated(event) {
      const formatEvent = {selectedPStage: event.selectedStage, pFilter: event.filter};
      this.$emit('p-filter-updated', {...formatEvent});
    },
    filterUpdated(event) {
      this.$emit('filter-updated', event);
    },
    setStage(data) {
      this.$emit('stage-updated', data);
    },
    createPStage() {
      this.selectedPStageId = 0;
      this.pStageModal = true;
    },
    openTestModal($event) {
      const { templateId, channelId } = $event;

      this.testTemplateId = templateId;
      this.testChannelId = channelId;
      this.testTemplateDialog = true;
    },
    closeTestModal() {
      this.testTemplateId = 0;
      this.testChannelId = 0;
      this.testTemplateDialog = false;

    },
    openChannelSettings($event) {
      const { channel, filter } = $event;
      this.showChannelSettings = true;
      this.editingFilter = filter;
      this.editingChannel = channel.name;
    },
    toggleAll(stageNumber) {
      this[`toggleAll${stageNumber}`] = !this[`toggleAll${stageNumber}`];
      if (this[`toggleAll${stageNumber}`]) {
        this[`stStatus${stageNumber}`] = 'up';
      } else {
        this[`stStatus${stageNumber}`] = 'down';
      }
    },
    createStage(isGlobal) {
      this.selectedStageId = 0;
      this.selectedStageGlobal = isGlobal;
      this.stageModal = true;
    },
    editStage(stage) {
      this.selectedStageId = stage.id;
      this.selectedStageGlobal = !!stage.global;
      this.stageModal = true;
    },
    editPStage(stage) {
      this.selectedPStageId = stage.id;
      this.pStageModal = true;
    },
    deleteStage(stage) {
      this.selectedStageId = stage.id;
      this.deleteMessage = '¿Deseas eliminar este segmento? Esta acción es irreversible.';
      this.deleteType = 'stage';
      this.deleteModal = true;
    },
    deletePStage(stage) {
      this.selectedPStageId = stage.id;
      this.deleteMessage = '¿Deseas eliminar este segmento? Esta acción es irreversible.';
      this.deleteType = 'p-stage';
      this.deleteModal = true;
    },
    deleteFilter(filter) {
      this.selectedFilter = filter;
      this.deleteType = 'filter';
      this.deleteModal = true;
    },
    deletedEvt() {
      this.stageModal = false;
      this.pStageModal = false;
      this.stageFilterModal = false;
      this.deleteModal = false;
      this.pFilterModal = false;

      const data = {
        ...this.deleteType === 'stage' && {
          ...this.selectedStage,
        },
        ...this.deleteType === 'p-stage' && {
          ...this.selectedPStage,
        },
        ...this.deleteType === 'stage-filter' && {
          selectedFilter: this.selectedFilter,
          selectedStage: this.selectedStage
        },
        ...this.deleteType === 'p-filter' && {
          pStage: this.selectedPStage,
          pFilter: this.selectedFilter,
        },
      };

      this.$emit(`${this.deleteType}-deleted`, data);
      if (this.deleteType === 'stage') {
        this.selectedStageId = 0;
      } else {
        this.selectedFilter = {};
        this.selectedPStageId = 0;
      }
    },
    async sendStageRequest(stageId, payload, isPaymentType) {
      let url = 'stages';

      if (isPaymentType) {
        url = 'payment_p_stages';
      }

      const updated = this.axios.patch(`${url}/${stageId}`, payload)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return false;
        });

      return updated;
    }
  },
  watch: {
    filtersModal() {
      if (!this.filtersModal) {
        this.selectedFilter = {};
      }
    },
    stageFilterModal() {
      if (!this.stageFilterModal) {
        this.selectedFilter = {};
        this.selectedStageId = 0;
        this.selectedStageFilter = {};
      }
    },
    pFilterModal() {
      if(!this.pFilterModal) {
        this.editingFilter = {};
        this.selectedPStageId = 0;
      }
    },
  },
};
</script>

<style scoped lang="css">
.priority-one {
  background-color: #263238;

}

.priority-two {
  background-color: #7C8387;

}

.priority-three {
  background-color: #BCC0C2;

}

.priority-frame {
  max-width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  margin-left: 0;
  padding: 0;
  position: relative;
  top: -12px;
  left: -24px;
}

.priority-icon {
  max-width: 100%;
  max-height: 100%;
}

.expansion-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.expand-icon-left {
  order: -1;
  margin-right: 8px;
}

.toggle-icon {
  cursor: pointer;
}

.expansion-panel__body .header__icon {
  position: static !important;
}

.custom-panel >>> .header__icon:not(.expansion-panel__body .header__icon) {
  position: absolute !important;
  left: 44px !important;
  top: 42px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowDetail/Index.vue